import React, { useContext, useEffect, useState } from 'react';
import InfoLineView, { InfoLine } from '../../Components/InfoLineView';
import { SunsetAPIContext } from '../../Networking/ApiProvider';
import './Stats.css';

interface Data {
    OnlinePlayers: number;
    'total-accounts': number;
    'total-characters': number;
    'total-factions': number;
    'total-vehicles': number;
    'total-properties': number;
    'total-account-punishments': number;
}

export default function Stats() {
    const [data, setData] = useState<Data | null>(null);
    const api = useContext(SunsetAPIContext);
    useEffect(() => {
        async function fetchData() {
            const endpoints = [
                'OnlinePlayers',
                'total-accounts',
                'total-characters',
                'total-factions',
                'total-vehicles',
                'total-properties',
                'total-account-punishments',
            ];

            const aggregatedData: Data = {
                OnlinePlayers: 0,
                'total-accounts': 0,
                'total-characters': 0,
                'total-factions': 0,
                'total-vehicles': 0,
                'total-properties': 0,
                'total-account-punishments': 0
            };

            for (const endpoint of endpoints) {
                const response = await fetch(`${api?.baseURL}api/ServerStats/${endpoint}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch data for ${endpoint}: ${response.statusText}`);
                }

                const fetchedData = await response.json();

                switch (endpoint) {
                    case 'total-accounts':
                        aggregatedData['total-accounts'] = fetchedData.data;
                        break;
                    case 'total-characters':
                        aggregatedData['total-characters'] = fetchedData.data;
                        break;
                    case 'total-factions':
                        aggregatedData['total-factions'] = fetchedData.data;
                        break;
                    case 'total-vehicles':
                        aggregatedData['total-vehicles'] = fetchedData.data;
                        break;
                    case 'total-properties':
                        aggregatedData['total-properties'] = fetchedData.data;
                        break;
                    case 'total-account-punishments':
                        aggregatedData['total-account-punishments'] = fetchedData.data;
                        break;
                    default:
                        break;
                }
            }

            setData(aggregatedData);
        }

        fetchData();
    }, []);

    return (
        <div className='stat-card'>
            <h2 className='stats-heading'>Server Stats</h2>
            <InfoLineView title="Server Information">
                <InfoLine label="Total Accounts" value={data?.['total-accounts']} />
                <InfoLine label="Total Characters" value={data?.['total-characters']} />
                <InfoLine label="Total Factions" value={data?.['total-factions']} />
                <InfoLine label="Total Vehicles" value={data?.['total-vehicles']} />
                <InfoLine label="Total Properties" value={data?.['total-properties']} />
                <InfoLine label="Total Account Punishments" value={data?.['total-account-punishments']} />
            </InfoLineView>
        </div>
    );
}